'use client'

import React from 'react';
import { StyledWidgetsHero } from './widgetsHero.styles';
import { Header } from '../header/header.comp';

interface IWidgetsHeroProps {
    title?: string;
    subtitle?: string;
}

export const WidgetsHero = ({ title, subtitle }: IWidgetsHeroProps) => {
    const heroTitle = title || `Find the Best Apps, Plugins and Widgets+ for Your Website`;
    const heroSubtitle = subtitle || `Explore our extensive selection of fully customizable & perfectly responsive apps, plugins and widgets+.`;

    return (
        <StyledWidgetsHero>
            <div className="hero-wrapper">
                <h1>{heroTitle}</h1>
                <h2>{heroSubtitle}</h2>
            </div>
        </StyledWidgetsHero>
    );
};
